import React from 'react';
import logo from '../assets/logo.svg';

type HeaderProps = { logoHref?: string; isInternal?: boolean };

export const Header: React.FC<HeaderProps> = ({ logoHref, isInternal }) => (
    <div>
        <header
            className="main-header"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px 24px' }}
        >
            <a
                href={logoHref}
                style={{
                    marginLeft: '24px',
                }}
            >
                <img src={logo} alt="logo" />
            </a>
            {isInternal && (
                <nav style={{ display: 'flex', gap: '20px', marginRight: '24px' }}>
                    <a href="/" className="menu-item">
                        API Docs
                    </a>
                    <a href="/changes" className="menu-item">
                        Changes
                    </a>
                </nav>
            )}
        </header>
        <hr
            style={{
                border: 'none',
                marginTop: 0,
                borderBottom: '1px solid  #fafafa',
                marginBottom: '1px',
                boxShadow: 'rgba(0, 0, 0, 0.8) 0px 0px 3px',
            }}
        />
    </div>
);
